// extracted by mini-css-extract-plugin
module.exports = {"collapse":"collapse--f0QQ5","panel":"panel--3JG7U"};